import React from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from '../../../../../utils/formatting';
import styles from '../activityStats.scss';

function ActivityStatCard({ title, mobileTitle, total, wins, losses, rank, rankDisplay, rankLabel, teaser, hideStatHeader, rankInfoText }) {
    const cardClassName = teaser ? `${styles.statCard} ${styles.statCardTeaser}` : styles.statCard;
    return (
        <div className={cardClassName}>
            {!hideStatHeader && (
                <div className={styles.statCardHeader}>
                    <span className={styles.statCardTitleDesktop}>{title}</span>
                    <span className={styles.statCardTitleMobile}>{mobileTitle || title}</span>
                </div>
            )}
            <div className={styles.statCardBody}>
                <div className={styles.statCardTopGroup}>
                    <div className={styles.statCardTotal}>{formatNumber(total)}</div>
                    <div className={styles.statCardDivider} />
                    <div className={styles.statCardWinLoss}>
                        <div className={styles.statCardWinCol}>
                            <span className={styles.statCardWinValue}>{formatNumber(wins)}</span>
                            <span className={styles.statCardWinLabel}>WINS</span>
                        </div>
                        <div className={styles.statCardWlDivider} />
                        <div className={styles.statCardLossCol}>
                            <span className={styles.statCardLossValue}>{formatNumber(losses)}</span>
                            <span className={styles.statCardLossLabel}>LOSSES</span>
                        </div>
                    </div>
                </div>
                {(rank != null || rankDisplay != null) && (
                    <React.Fragment>
                        <div className={styles.statCardDivider} />
                        <div className={styles.statCardRank}>
                            {rankLabel && <span className={styles.statCardRankLabel}>{rankLabel}</span>}
                            <span className={styles.statCardRankValue}>{rank != null ? formatNumber(rank) : rankDisplay}</span>
                            {rankInfoText && <span className={styles.statCardRankInfo}>{rankInfoText}</span>}
                        </div>
                    </React.Fragment>
                )}
            </div>
        </div>
    );
}

ActivityStatCard.propTypes = {
    title: PropTypes.string.isRequired,
    mobileTitle: PropTypes.string,
    total: PropTypes.number,
    wins: PropTypes.number,
    losses: PropTypes.number,
    rank: PropTypes.number,
    rankDisplay: PropTypes.string,
    rankLabel: PropTypes.string,
    teaser: PropTypes.bool,
    hideStatHeader: PropTypes.bool,
    rankInfoText: PropTypes.string,
};

ActivityStatCard.defaultProps = {
    mobileTitle: null,
    total: 0,
    wins: 0,
    losses: 0,
    rank: null,
    rankDisplay: null,
    rankLabel: null,
    teaser: false,
    hideStatHeader: false,
    rankInfoText: null,
};

export default ActivityStatCard;
